/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedDTO_PatientIndexDTO_ } from '../models/PaginatedDTO_PatientIndexDTO_'
import type { PatientDTO } from '../models/PatientDTO'
import type { PatientUpsertDTO } from '../models/PatientUpsertDTO'
import type { PatientUpsertResponseDTO } from '../models/PatientUpsertResponseDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenPatientsService {
    /**
     * Export Patients
     * Export all matching patients as a CSV file.
     * Supports the same filters as the patients list endpoint.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportPatientsPatientsExportGet({
        sort,
        search,
        patientManagerId,
        carePartnerId,
        cioxStatus,
        hasFailedRequests
    }: {
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
        /**
         * Search term
         */
        search?: string | null
        /**
         * Filter by patient manager ID
         */
        patientManagerId?: string | null
        /**
         * Filter by care partner ID
         */
        carePartnerId?: string | null
        /**
         * Filter by rolled-up CIOX request status
         */
        cioxStatus?: string | null
        /**
         * Filter patients who have failed or needs attention greenlight requests
         */
        hasFailedRequests?: boolean | null
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patients/export',
            query: {
                sort: sort,
                search: search,
                patient_manager_id: patientManagerId,
                care_partner_id: carePartnerId,
                ciox_status: cioxStatus,
                has_failed_requests: hasFailedRequests
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Index
     * Get paginated list of patients with optimized request summary counts.
     *
     * Supports searching across patient name, email, phone, site, and ID fields.
     * Can filter by patient manager ID, care partner ID, and patients with failed or needs attention greenlight requests.
     * @returns PaginatedDTO_PatientIndexDTO_ Successful Response
     * @throws ApiError
     */
    public static indexPatientsGet({
        page = 1,
        limit = 10,
        sort,
        search,
        patientManagerId,
        hasFailedRequests,
        carePartnerId,
        cioxStatus
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
        /**
         * Search across patient name, email, phone, site, and ID fields
         */
        search?: string | null
        /**
         * Filter patients by patient manager ID
         */
        patientManagerId?: string | null
        /**
         * Filter patients who have failed or needs attention greenlight requests
         */
        hasFailedRequests?: boolean | null
        /**
         * Filter patients by care partner ID
         */
        carePartnerId?: string | null
        /**
         * Filter patients by their rolled-up CIOX request status. One of: NOT_REQUESTED, NONE, SENT_TO_CIOX, CIOX_RETRIEVAL_FAILED, RECORDS_RECEIVED_VIA_CIOX. NOT_REQUESTED means no CIOX request exists for the patient, which is distinct from NONE (a request exists but has not been sent).
         */
        cioxStatus?: string | null
    }): CancelablePromise<PaginatedDTO_PatientIndexDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patients',
            query: {
                page: page,
                limit: limit,
                sort: sort,
                search: search,
                patient_manager_id: patientManagerId,
                has_failed_requests: hasFailedRequests,
                care_partner_id: carePartnerId,
                ciox_status: cioxStatus
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Upsert
     * Upsert patient endpoint.
     *
     * Creates or updates a patient record and handles provider relationships.
     * @returns PatientUpsertResponseDTO Successful Response
     * @throws ApiError
     */
    public static upsertPatientsPost({ requestBody }: { requestBody: PatientUpsertDTO }): CancelablePromise<PatientUpsertResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/patients',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * @returns PatientDTO Successful Response
     * @throws ApiError
     */
    public static getPatientsPatientIdGet({ patientId }: { patientId: string }): CancelablePromise<PatientDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patients/{patient_id}',
            path: {
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete Patient
     * Delete a patient.
     * Automatically logs deletion to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deletePatientPatientsPatientIdDelete({ patientId }: { patientId: string }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/patients/{patient_id}',
            path: {
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
